import React from "react";
import { Badge } from "../components/ui/badge";
import { APPLICATION_STATUSES } from "../lib/constants";

export default function StatusBadge({ status, testId }) {
  const cfg = APPLICATION_STATUSES[status] || {
    label: status || "—",
    className: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return (
    <Badge
      variant="outline"
      className={`${cfg.className} font-medium px-2.5 py-0.5`}
      data-testid={testId || `status-${status}`}
    >
      {cfg.label}
    </Badge>
  );
}
